import { Link } from 'react-router-dom';
import { useLanguage } from '../language/LanguageContext';

function NotFound() {
  const { t } = useLanguage();

  return (
    <section className="not-found">
      <p className="eyebrow">{t.notFound.eyebrow}</p>
      <h1>{t.notFound.title}</h1>
      <p>{t.notFound.text}</p>
      <Link className="button primary" to="/">
        {t.notFound.cta}
      </Link>
    </section>
  );
}

export default NotFound;
